import React, { useState, useEffect } from 'react'
import {
  TextOutGoing,
  TextWrap,
  TextWrap_CXL,
  TextWrap_XLVB,
  TextWrapUnread,
  TextWrapUnread_CXL,
  TextWrapUnread_XLVB,
  trimOverlengthString,
  UnReadTextOutGoing,
} from '../Common/CellText'
import authenticationStore from '../../stores/authenticationStore'
import { INTERNAL_DOCUMENT_INCOMING_STATUS } from '../../constants'

const UnreadTextOutGoing = props => {
  const { currentUser, isCheckVTXL } = authenticationStore

  const [isVTXL, setVTXL] = useState(null)

  useEffect(() => {
    const fetchCurrentUser = async () => {
      const checkVTXL = await authenticationStore.isCheckVTXL
      setVTXL(checkVTXL)
    }

    fetchCurrentUser()
  }, [])

  return props.isUnread ? (
    <UnReadTextOutGoing>
      {trimOverlengthString(props.text, props.width)}
    </UnReadTextOutGoing>
  ) : (
    <TextOutGoing>{trimOverlengthString(props.text, props.width)}</TextOutGoing>
  )
}

export default UnreadTextOutGoing
